import {
  EnrolleeStatusDisplayName,
  EnrolleeStatusEnum,
} from "pmt-types/src/enums/EnrolleeStatus.ts";
import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { Project } from "pmt-types/src/models/Project.ts";
import { Source } from "pmt-types/src/models/Source.ts";

import { useNavigate } from "react-router-dom";
import SearchPage from "../../components/search/searchPage.tsx";
import formatDateString from "../../utils/formatDateString.ts";

export default function EnrolleesList() {
  const navigate = useNavigate();

  return (
    <SearchPage<Enrollee>
      route="enrollees"
      allowEntityCreate={true}
      createButtonLabel={"Enroll Contractor"}
      resultsColumnDef={[
        {
          accessorKey: "name",
          id: "name",
          cell: (info) => info.getValue(),
          header: "Enrollee",
          minSize: 400,
        },
        {
          accessorKey: "status",
          id: "status",
          cell: (info) =>
            EnrolleeStatusDisplayName[info.getValue() as EnrolleeStatusEnum],
          header: "Status",
          minSize: 100,
        },
        {
          accessorKey: "source",
          id: "source",
          cell: (info) => (info.getValue() as Source)?.name,
          header: "Source",
        },
        {
          accessorKey: "project",
          id: "project",
          cell: (info) => (info.getValue() as Project)?.name,
          header: "Project",
        },
        {
          accessorKey: "updatedDate",
          id: "updatedDate",
          cell: (info) => formatDateString(info.getValue() as string),
          header: "Last Updated",
        },
        {
          id: "view",
          cell: (info) => (
            <div className="flex items-center justify-around mr-4">
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(
                    `/sources/${info.row.original.source.id}/projects/${info.row.original.project.id}/enrollees/${info.row.original.id}/details`,
                  );
                }}
              >
                View
              </a>
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(
                    `/sources/${info.row.original.source.id}/projects/${info.row.original.project.id}/enrollees/${info.row.original.id}?return=search`,
                  );
                }}
              >
                Edit
              </a>
            </div>
          ),
          header: "",
          maxSize: 100,
        },
      ]}
    />
  );
}
